import { ActiveRecordingConflictModal } from "@/components/modal/active-recording-conflict";
import { SystemAudioRecordingFailedModal } from "@/components/modal/system-audio-recording-failed";
import { MessageOverlay } from "@/components/overlay/message-overlay/message-overlay";
import { StandardSyncErrorOverlay } from "@/components/error-handling/sync-error-overlay";
import { DebugInfoOverlay } from "@/components/error-handling/debug-info-overlay";
import { WelcomeOverlay } from "@/components/onboarding/welcome-overlay";
import { observer } from "mobx-react-lite";

interface AppOverlaysProps {}

export const StandardModeAppAppOverlays = observer<AppOverlaysProps>(() => {
  return (
    <>
      <ActiveRecordingConflictModal />
      <SystemAudioRecordingFailedModal />
      <MessageOverlay />
      <StandardSyncErrorOverlay />
      <DebugInfoOverlay />
      <WelcomeOverlay />
    </>
  );
});
